export default "/_next/static/images/Brightoldmoney-6b3d3c7a47d6f5fc1d050cafb0f38eca.png";